import {
  META_MODEL_CUT_SIZE_MULTIPLIER,
  MODEL_SCORING_TYPE,
  type ModelScoringTypeValue,
} from '../constants';

export const CSV_FILE_FORMAT_ERROR =
  'The CSV file should contain a single column with no header, and include only valid audience IDs';
export const VALID_FILE = 'Valid file';
export const ERROR_PROCESSING_FILE = 'Error occurred during file processing';
export const IN_PROGRESS = 'In Progress';
export const COPY_POPOVER_TITLE = 'Click to copy and view text';
export const CLICK_TO_VIEW_ERROR_DETAILS = 'Click to view error details';
export const IMPORTING_FILE = 'Importing file';
export const SUCCESS_FILE = 'Import Complete';
export const CHANGE_LOG = 'Change Log';
export const CHANGE_LOG_DATE = 'Date';
export const CHANGE_LOG_CHANGED_BY = 'Changed By';
export const CHANGE_LOG_CHANGED_FIELDS = 'Changed Fields';
export const NO_DATA = 'No Data';
export const JSON_VIEW = 'Json View';
export const FIELD_NAME = 'Field Name';
export const OLD_VALUE = 'Old Value';
export const NEW_VALUE = 'New Value';
export const TARGETING_TESTING = 'Targeting Testing';
export const USER_ID_EMAIL = 'User ID/Email';
export const CLEAR_FILTERS = 'Clear Filters';
export const TEST_TARGETING = 'Test Targeting';
export const DELETE_AB_TEST = 'Delete A/B Test';
export const CREATE = 'Create';
export const EDIT = 'Edit';
export const SAVE = 'Save';
export const SAVE_ANYWAY = 'Save Anyway';
export const CANCEL = 'Cancel';
export const WAIT = 'Wait';
export const DELETE = 'Delete';
export const SAVE_AUDIENCE = 'Save audience?';
export const YES = 'YES';
export const NO = 'NO';
export const NA = 'N/A';
export const AUDIENCE_HAS_BEEN_EDITED =
  'The audience has been edited, do you want to save and continue ?';
export const AUDIENCE_SIZE_STILL_FETCHING =
  'The seed audience size is still being calculated. Saving now may lead to an incorrect audience count being stored.';
export const PLEASE_FILL_OUT_ALL_POSSIBLE_RESPONSES =
  'Please fill out all possible responses.';
export const SUCCESSFULLY_CREATED_AB_TEST = 'Successfully created AB Test';
export const AB_TEST_NAME = 'A/B Test Name';
export const EDIT_AB_TEST = 'Edit A/B Test';
export const STEP_1 = 'Step 1';
export const STEP_2 = 'Step 2';
export const AB_TEST_1 = 'A/B Test 1';
export const SELECT_PLACEMENT = 'Select Placement';
export const TEST_TYPE = 'Test Type';
export const RANDOM = 'Random';
export const PERCENTAGE = 'Percentage';
export const SLOTS = 'Slots';
export const STATUS = 'Status';
export const STEP_3 = 'Step 3';
export const CLOSE = 'Close';
export const SELECT_CATEGORIES = 'All Categories';
export const REMOVE_AB_TEST = 'Remove A/B Test';
export const SUCCESSFULLY_DELETED_AB_TEST = 'Successfully deleted A/B Test';
export const FAILED_TO_DELETE_AB_TEST = 'Failed to delete A/B Test';
export const ERROR_FETCHING_GROUPS = 'Error fetching groups';
export const DUPLICATE = 'Duplicate';
export const NO_CURRENT_GROUP = 'No current group.';
export const UPLOADING = 'Uploading';

export const AUDIENCE_STUDIO = 'Audience Studio';
export const CUSTOM_AUDIENCES = 'Custom Audiences';
export const CREATE_AUDIENCE = 'Create Audience';
export const CREATE_GROUP = 'Create Group';
export const SELECT_GROUP = 'Select group';
export const ESTIMATED_AUDIENCE_SIZE = 'Estimated Audience Size';
export const MODELING_STATUS = 'Modeling Status';
export const SEED_AUDIENCE_SIZE = 'Seed Audience Size';
export const LAST_MODIFIED = 'Last modified';
export const NEW_GROUP = 'New Group';
export const HOW_TO_NAME_NEW_GROUP = 'How do you want to name the new group?';
export const MODEL_YOUR_AUDIENCE = 'Model your audience';
export const YOUR_AUDIENCE_IS_BEING_MODELED =
  'Your audience is getting modeled.';
export const YOUR_AUDIENCE_FAILED_TO_GET_MODELED =
  'Your audience failed to get modeled';
export const EST_AUDIENCE_SIZE_MODELED_VALIDATION_MESSAGE =
  'Modeling Error: Your ADS seed audience must include at least 1000 individuals. Please refresh audience size to view the latest audience size';
export const EST_AUDIENCE_SIZE_MODELED_WARNING_MESSAGE =
  'Warning: We suggest that your ADS seed audience contains at least 2,000 individuals';
export const AUDIENCE_NAME_LENGTH_VALIDATION_MESSAGE =
  'Audience name should not exceed 175 characters';
export const SELECT_AUDIENCE_SIZE_INFORMATION_TEXT =
  'A 1% lookalike consists of the people most similar to your lookalike audience source. Increasing the percentage creates a bigger, broader audience.';
export const SELECT_AUDIENCE_SIZE_PRICE_OPTIMIZATION_INFORMATION_TEXT =
  'Price optimization re-ranks your lookalike audience by predicated bid value. Tighter cuts surface your highest-CPM users first - same destinations, higher economic value.';
export const MODEL_SCORING_TYPE_LABEL = 'Model Scoring Mode';

export const MODEL_SCORING_MODE_BETA_BADGE = 'BETA';
export const VALUE_CLASS_COMPOSITION_LABEL = 'Value class composition';
export const VALUE_CLASS_HIGH_LABEL = 'High';
export const VALUE_CLASS_MID_LABEL = 'Mid';
export const VALUE_CLASS_LOW_LABEL = 'Low';
export const VALUE_CLASS_HIGH_FULL_LABEL = 'High Value';
export const VALUE_CLASS_MID_FULL_LABEL = 'Medium Value';
export const VALUE_CLASS_LOW_FULL_LABEL = 'Low Value';
export const VALUE_CLASS_COMPOSITION_EMPTY_MESSAGE =
  'To view the values, please run the model again. Values are currently unavailable for historic modeling.';
export const MODEL_SCORING_METRIC_HIGH_VALUE_USERS = 'HIGH VALUE USERS';
export const MODEL_SCORING_METRIC_ECPM_LIFT = 'EST. ECPM LIFT';
export const MODEL_SCORING_METRIC_TOTAL_AUDIENCE = 'TOTAL AUDIENCE';

export const MODEL_SCORING_MODE_TAB_CONFIG: Record<
  ModelScoringTypeValue,
  { title: string; subtitle: string; showBeta: boolean }
> = {
  [MODEL_SCORING_TYPE.LAL]: {
    title: 'Lookalike (current)',
    subtitle: 'Similarity-based ranking.',
    showBeta: false,
  },
  [MODEL_SCORING_TYPE.CPM_V1]: {
    title: 'Price optimization',
    subtitle: 'CPM value-based ranking.',
    showBeta: true,
  },
};
export const EXPORT_HISTORY = 'Export History';
export const ADD_AUDIENCE_DETAILS = 'Add your audience details';

export const POINT_CHANGE_END_DATE_ERROR_MESSAGE =
  'End Date must be greater than Start Date';

export const AUDIENCE_EXPORT_SUCCESS_MESSAGE =
  'Success! Your audience is now being delivered.';
export const AUDIENCE_EXPORT_FAILED_MESSAGE = 'Your audience failed to export';
export const AUDIENCE_MODEL_SKIP_MESSAGE = `Increase the size of your audience by using Attain's look-alike machine learning models.`;
export const ACTIVE_AUDIENCES = 'Active Audience';

// Timeframe Warning Modal
export const TIMEFRAME_WARNING_MODAL_HEADER = 'Warning';
export const TIMEFRAME_WARNING_MESSAGE =
  'Warning: Extended timeframes may cause performance issues.';
export const TIMEFRAME_WARNING_CANCEL_BUTTON = 'Cancel timeframe selection';
export const TIMEFRAME_WARNING_ACCEPT_BUTTON = 'Accept';
export const ERROR_PAGE_NOT_EXIST = '404 Error: This page does not exist.';
export const ERROR_FETCHING_AUDIENCE = 'Error while feching audiences';

// Compliance Warning Modal (audience export — globally restricted categories)
export const COMPLIANCE_WARNING_MODAL_TITLE = 'Warning';
export const COMPLIANCE_WARNING_PRIMARY_LEAD =
  'This audience may not be eligible for export. The Segment name and/or Description includes terms that match';
export const COMPLIANCE_WARNING_PRIMARY_EMPHASIS =
  'globally restricted categories.';
export const COMPLIANCE_WARNING_TABLE_ARIA_LABEL =
  'Globally restricted categories and matched terms';
export const COMPLIANCE_WARNING_TABLE_COL_CATEGORY = 'Category';
export const COMPLIANCE_WARNING_TABLE_COL_POLICY = 'Policy';
export const COMPLIANCE_WARNING_TABLE_COL_MATCHED = 'Matched Keywords / Brands';
export const COMPLIANCE_WARNING_POLICY_FULL_BAN = 'Full ban';
export const COMPLIANCE_WARNING_POLICY_PARTIAL_BAN = 'Partial ban';
export const COMPLIANCE_WARNING_TABLE_EMPTY = 'No violations to display.';
export const COMPLIANCE_WARNING_SUB_TEXT =
  'To proceed with this export, you must acknowledge this warning. Otherwise, cancel the export & rebuild in a compliant fashion.';
export const COMPLIANCE_WARNING_CANCEL_EXPORT_BUTTON = 'Cancel Export';
export const COMPLIANCE_WARNING_CONTINUE_BUTTON = 'Ignore and continue';
export const COMPLIANCE_WARNING_AUTHORISED_ONLY_TOOLTIP =
  'Only authorised users can proceed with export.';
export const COMPLIANCE_WARNING_EMPTY_CELL = '—';
export const COMPLIANCE_EXPORT_BLOCKED_USE_ACTIVE_AUDIENCE =
  'This export was flagged by audience compliance. Open the Active Audience tab and use Export there to review details and continue if authorised.';
export const COMPLIANCE_WARNING_BLOCKED_NO_BAN_ROWS =
  'This export is blocked by audience compliance. Update segment name and description, or contact support if you need help.';

// Refresh Audience Size Warning Modal
export const REFRESH_AUDIENCE_SIZE_WARNING_MESSAGE =
  'Please avoid repeatedly clicking Refresh Audience Size. Each click runs an expensive query. Wait for it to complete and refresh audience only after all required conditions are set.';
export const REFRESH_AUDIENCE_SIZE_CANCEL_BUTTON =
  'Cancel Refresh Audience Size';
export const REFRESH_AUDIENCE_SIZE_ACCEPT_BUTTON = 'Accept';
export const AUDIENCE_EXPORT_FIELD_TITLES = {
  ots_segment: 'The Trade Desk',
  custom_segment: 'The Trade Desk Custom',
  liveramp_custom_segment: 'Liveramp Custom',
  liveramp_ots_segment: 'Liveramp OTS',
  experian_ots_segment: 'Experian OTS',
  ttd_ots_segment_seed_audience: 'The Trade Desk (Seed)',
  ttd_custom_segment_seed_audience: 'The Trade Desk Custom (Seed)',
  liveramp_ots_segment_seed_audience: 'Liveramp OTS (Seed)',
  liveramp_custom_segment_seed_audience: 'Liveramp Custom (Seed)',
  meta_custom_segment_seed_audience: 'Meta (Seed)',
  meta_custom_segment: 'Meta Custom',
  yahoo_dsp_ots_segment: 'Yahoo DSP OTS',
  yahoo_dsp_custom_segment: 'Yahoo DSP Custom',
  tiktok_custom_segment: 'TikTok Custom',
  tiktok_custom_segment_seed_audience: 'TikTok Custom (Seed)',
  reddit_custom_segment: 'Reddit Custom',
  amazon_custom_segment: 'Amazon Custom',
  amazon_ots_segment: 'Amazon OTS',
  openx_ots_segment: 'OpenX OTS',
  openx_custom_segment: 'OpenX Custom',
  appsflyer_custom_segment: 'AppsFlyer Custom',
  viant_custom_segment: 'Viant Custom',
  nexxen_ots_segment: 'Nexxen OTS',
  nexxen_custom_segment: 'Nexxen Custom',
};

export enum LIVERAMP_SEGMENT_FIELD_NAME {
  PROGRAMMATIC_PERCENT_OF_MEDIA = 'Programmatic % of media',
  CPM = 'CPM',
  DESCRIPTION = 'Description',
  CUSTOM_SEGMENT_NAME = 'Custom Segment Name',
  TV_TARGETING = 'TV Targeting',
  ADVERTISER_DIRECT = 'Advertiser Direct % of Media',
  CHOOSE_INTEGRATION = 'Choose Integration (Destination)',
  CHOOSE_ADVERTISER = 'Choose Advertiser (Distribution Manager)',
}

export enum META_SEGMENT_FIELD_NAME {
  META_AD_ACCOUNT_ID = 'Meta Ad Account ID',
  MODEL_CUT_SIZE = 'Model Cut Size',
}

export enum YAHOO_DSP_SEGMENT_FIELD_NAME {
  PARTNER_ID = 'Partner ID (MDM ID)',
  TV_CPM = 'TV CPM',
}

export enum TIKTOK_SEGMENT_FIELD_NAME {
  ADVERTISER_ID = 'Advertiser ID',
  MOBILE_OS = 'Mobile OS',
  AUDIENCE_SIZE = 'Audience Size',
  PLACEMENTS = 'Placements',
}

export enum REDDIT_SEGMENT_FIELD_NAME {
  REDDIT_AD_ACCOUNT_ID = 'Reddit Ad Account ID',
}

export enum AMAZON_SEGMENT_FIELD_NAME {
  ADVERTISER_ID = 'Advertiser ID',
}

export enum OPENX_SEGMENT_FIELD_NAME {
  CATEGORY = 'Category',
  SUB_CATEGORY = 'Sub Category',
  TYPE = 'Type',
}

export enum APPSFLYER_SEGMENT_FIELD_NAME {
  COLLABORATOR_ID = 'Collaborator ID',
}

export enum VIANT_SEGMENT_FIELD_NAME {
  DESCRIPTION = 'Description',
  ACCOUNT_ID = 'Account ID',
  ADVERTISER_ID = 'Advertiser ID',
}

export enum NEXXEN_SEGMENT_FIELD_NAME {
  SEGMENT_NAME = 'Segment Name',
  AVAILABILITY = 'Availability',
  ADVERTISER_ID = 'Advertiser ID',
  MARKET_ID = 'Market ID',
  RATE_TYPE = 'Rate Type',
  CURRENCY_RATE = 'Currency Rate',
  START_DATE = 'Start Date',
  END_DATE = 'End Date',
}

// Nexxen Rate Type option keys (stored in DB)
export const NEXXEN_RATE_TYPE_CPM = 'CPM';
export const NEXXEN_RATE_TYPE_PM = 'PM';
export const NEXXEN_RATE_TYPE_FF = 'FF';
export const NEXXEN_RATE_TYPE_CPMAP = 'CPMAP';

// Nexxen Rate Type option labels (displayed in UI)
export const NEXXEN_RATE_TYPE_CPM_LABEL = 'CPM';
export const NEXXEN_RATE_TYPE_PM_LABEL = 'Percent of Media';
export const NEXXEN_RATE_TYPE_FF_LABEL = 'Flat Fee';
export const NEXXEN_RATE_TYPE_CPMAP_LABEL = 'CPMAP';

// Nexxen Availability option keys
export const NEXXEN_AVAILABILITY_ALL = 'ALL';
export const NEXXEN_AVAILABILITY_SINGLE = 'SINGLE';

// Nexxen Availability option labels (displayed in UI)
export const NEXXEN_AVAILABILITY_ALL_LABEL = 'All Advertisers';
export const NEXXEN_AVAILABILITY_SINGLE_LABEL = 'Single Advertiser';

/** Prefilled in development/staging/local builds only (see InlineAudienceExport). */
export const NEXXEN_NONPROD_DEFAULT_MARKET_ID = '59';
export const NEXXEN_NONPROD_DEFAULT_ADVERTISER_ID = '356582852';

/** Shown under locked Advertiser ID field (non-production Nexxen custom only). */
export const NEXXEN_NONPROD_DEFAULT_ADVERTISER_LOCKED_HELPER =
  `Advertiser ID value is restricted.`;
/** Shown under locked Market ID field (non-production Nexxen custom only). */
export const NEXXEN_NONPROD_DEFAULT_MARKET_LOCKED_HELPER =
  `Market ID value is restricted.`;

// TikTok Mobile OS option labels
export const TIKTOK_MOBILE_OS_ALL = 'All';
export const TIKTOK_MOBILE_OS_ANDROID = 'Android';
export const TIKTOK_MOBILE_OS_IOS = 'IOS';

// TikTok Audience Size option labels
export const TIKTOK_AUDIENCE_SIZE_NARROW = 'Narrow';
export const TIKTOK_AUDIENCE_SIZE_BALANCED = 'Balanced';
export const TIKTOK_AUDIENCE_SIZE_BROAD = 'Broad';

// TikTok Placements option labels
export const TIKTOK_PLACEMENT_TIKTOK = 'TikTok';
export const TIKTOK_PLACEMENT_PANGLE = 'Pangle';
export const TIKTOK_PLACEMENT_GLOBAL_APP_BUNDLE = 'Global App Bundle';

// TikTok Placements tooltip
export const TIKTOK_PLACEMENTS_TOOLTIP =
  'Note: The Global App Bundle placement does not support the optimization goal Landing Page View (optimization_goal = TRAFFIC_LANDING_PAGE_VIEW)';

export enum TRADE_DESK_SEGMENT_FIELD_NAME {
  ADVERTISER_ID = 'Advertiser ID',
  PARTNER_ID = 'Partner ID',
  PERCENT_OF_MEDIA = '% of media',
  CPM = 'CPM',
  DESCRIPTION = 'Description',
  CUSTOM_SEGMENT_NAME = 'Custom Segment Name',
  OTS_SEGMENT_NAME = 'OTS Segment Name',
}

export const AUDIENCE_MANAGER_COLUMN_TITLES = {
  GROUP: 'Group',
  NAME: 'Name',
  AUDIENCE_STATUS: 'Audience Status',
  TYPE: 'Type',
  PLATFORM: 'Platform',
  ESTIMATED_SIZE: 'Est. Size',
  LAST_MODIFIED: 'Last Modified',
};

export const EXPORT_HISTORY_HEADERS = {
  DATE_TIME: { label: 'Export Date', width: '7%' },
  PLATFORM: { label: 'Platform', width: '13%' },
  STATUS: { label: 'Status', width: '9%' },
  ESTIMATED_SIZE: { label: 'Seed Size', width: '9%' },
  DELIVERED_SIZE: { label: 'Delivered Size', width: '9%' },
  CUT_SIZE: { label: 'Cut Size', width: '6%' },
  CPM: { label: 'CPM', width: '5%' },
  POM: { label: 'PoM', width: '5%' },
  EMAIL: { label: 'Email', width: '20%' },
  NAME: { label: 'Name', width: '26%' },
};

export const NO_RECORDS_FOUND = 'No records found';
export const ERROR_BOUNDARY_MESSAGE =
  'Whoops, looks like we had an error. Please return to the homepage or clear cache & re-login. If the error persists, please reach out to our team. Thanks!';
export const RETURN_TO_HOMEPAGE = 'Return to homepage';
export const CLEAR_CACHE_AND_RELOGIN = 'Clear cache & Re-login';
export const REDIRECTING = 'Redirecting...';
export const CLEARING_CACHE = 'Clearing cache...';

export const CLICKS = 'Clicks';
export const IMPRESSIONS = 'Total Impressions';
export const IN_HOUSE_LABEL = 'In-House';
export const TRANSUNION_LABEL = 'TransUnion';
export const RECOMMANDED = 'Recommended';
export const CHOOSE_AN_AUDIENCE_TYPE = 'Choose an audience type';
export const WAIT_FOR_AUDIENCE_LOAD = 'Wait for Audience Load';
export const EDIT_AUDIENCE_NAME = 'Edit Audience Name';
export const AUDIENCE_HISTORY = 'Audience History';
export const AUDIENCE_NAME = 'Audience Name';
export const SAVE_AUDIENCE_TITLE = 'Save Audience';
export const BUILD_FROM_SCRATCH = 'Build from scratch';
export const BUILD_FROM_SCRATCH_SUB_TEXT =
  'Target specific purchase behaviors, demographics, or survey questions';
export const COMBINE_EXISTING = 'Combine existing';
export const COMBINE_EXISTING_SUB_TEXT =
  'Combine your pre-existing ADS audiences into a single, new audience';
export const AUDIENCE_DESIGNER = 'Audience Designer';
export const AUDIENCE_DESIGNER_SUB_TEXT =
  'Use our Query Builder to target specific purchase behaviors, demographics, or survey questions';
export const AUDIENCE_BLENDER = 'Audience Blender';
export const AUDIENCE_BLENDER_SUB_TEXT =
  'Combine multiple modeled audiences into a single, new audience';
export const AUDIENCE_FILE = 'Audience File';
export const AUDIENCE_FILE_SUB_TEXT =
  'Upload your KloverIDs to generate a seed audience.';
export const CREATE_WITH_TRANSUNION = 'Create with TransUnion';
export const CREATE_WITH_IN_HOUSE = 'Create with In-House Modeling';
export const GROUP_DONE_NOT_HAVE_AUDIENCE = `This group doesn't have any audiences yet`;
export const GROUP_DONE_NOT_HAVE_AUDIENCE_WITH_FILTERS = `This group doesn't have any audiences with applied filters`;
export const CREATE_AUDIENCE_BY_CLICKING = `Start by clicking "Create Audience"`;
export const GETTING_AUDIENCE_BY_UPATING_FILTERS = `Start getting audience by updating applied filters`;
export const POINT_CHANGE_DATE = 'Date & Time';
export const POINT_CHANGE_VALUE = 'Value';
export const POINT_CHANGE_START_DATE = 'Points Change Start Date';
export const POINT_CHANGE_END_DATE = 'Points Change End Date';
export const POINT_CHANGE_START_VALUE = 'Points Change Start Value';
export const POINT_CHANGE_END_VALUE = 'Points Change End Value';
export const DATE_CANNOT_BE_IN_PAST = 'Date cannot be in the past';
export const DATE_CANNOT_BE_AFTER_90_DAYS = 'Date cannot be after 90 days';
export const ENTER_AUDIENCE_NAME_TO_CONTINUE =
  'Enter an audience name to continue';
export const PLEASE_REMOVE_HEADER_BEFORE_UPLOADING =
  'Please remember to remove header before uploading.';
export const META_MODEL_CUT_SIZE = `About ${META_MODEL_CUT_SIZE_MULTIPLIER}M IDs`;

export const AUDIENCE_MANAGER_FILTER_LABLES = {
  AUDIENCE_TYPE: 'All Types',
  PLATFORM: 'All Platforms',
};

export const PUSHER_ENV_MISSING_MESSAGE =
  'Pusher environment variables are missing';
export const PUSHER_CONNECTED_MESSAGE = 'Pusher connected successfully';
export const PUSHER_DISCONNECTED_MESSAGE = 'Pusher disconnected';
export const PUSHER_SUBSCRIBED_MESSAGE = 'Successfully subscribed to channel';
export const PUSHER_SUBSCRIBED_ERROR_MESSAGE = 'Failed to subscribe to channel';
export const PUSHER_CONNECTION_ERROR_MESSAGE = 'Pusher connection error';
export const PUSHER_CONNECTION_CLOSED_MESSAGE = 'Pusher connection closed';
export const PUSHER_EMAIL_VALIDATION_MESSAGE =
  'Email is required to create user channel';
export const SURVEY_MIN_ANSWER_REQUIRED =
  'At least one answer must be selected';
export const DEPRECATED_CONDITION_TOOLTIP =
  'This condition type is no longer available. You can only delete it.';
export const SURVEY_ADD_MIN_ANSWER_IN_SURVEY_TO_SAVE_AUDIENCE =
  'Add at least one answer in the survey to save the audience';
export const PAGE_NOT_FOUND_MESSAGE = '404 Error: This page does not exist.';
export const TYPE_AT_LEAST_3_CHARACTERS = 'Type at least 3 characters';

// Export Failure Log Popup
export const EXPORT_FAILURE_LOG_TITLE = 'Export Failure Log';
export const ERROR_CODE_LABEL = 'Error Code';
export const MESSAGE_LABEL = 'Message';
export const EXPORT_ID_LABEL = 'Export ID';
export const SUGGESTED_ACTION_LABEL = 'Suggested Action';
export const LAST_UPDATED_LABEL = 'Last Updated';
export const NO_ERROR_DETAILS_AVAILABLE = 'No error details available';
export const UNKNOWN_TIMESTAMP = 'Unknown';
export const VIEW_ERROR_CONTEXT = 'View error context';
export const EXPORT_TYPE_LABEL = 'Export Type';
export const PLATFORM_LABEL = 'Platform';

// HTTP Status Text
export const EXPORT_HISTORY_LOAD_ERROR_MESSAGE =
  'Failed to load export history. Please refresh the page.';

export const HTTP_STATUS_TEXTS: { [key: number]: string } = {
  400: 'Bad Request',
  401: 'Unauthorized',
  403: 'Forbidden',
  404: 'Not Found',
  500: 'Internal Server Error',
  502: 'Bad Gateway',
  503: 'Service Unavailable',
};

// OAuth URLs
export const OAUTH_URLS = 'OAuth URLs';
export const SEGMENT_MANAGER = 'Segment Manager';
export const SEGMENT_RATE_LEVEL_FILTER = 'Rate Level';
export const CREATE_OAUTH_URL = 'Create OAuth URL';
export const PLATFORM = 'Platform';
export const CLIENT_NAME = 'Client Name';
export const DESCRIPTION = 'Description';
export const OAUTH_URL_CREATED_SUCCESS = 'OAuth URL created successfully!';
export const COPY_OAUTH_URL = 'Copy';
export const OAUTH_URL_COPIED = 'OAuth URL copied to clipboard!';
export const OAUTH_URL_CREATE_ERROR = 'Failed to create OAuth URL';
export const CLICK_TO_VIEW_FULL_OAUTH_URL = 'Click to view full OAuth URL';
export const OAUTH_URL = 'OAuth URL';
export const ADVERTISER_ID = 'Advertiser/Account ID';
export const CREATED_BY = 'Created By';
export const CREATED_AT = 'Created At';
export const AMAZON_ADVERTISER_ID = 'Amazon Advertiser ID';
export const REDDIT_AD_ACCOUNT_ID = 'Reddit Ad Account ID';
export const TIKTOK_ADVERTISER_ID = 'TikTok Advertiser ID';
export const VIANT_ACCOUNT_ID = 'Viant Account ID';
export const CONNECTION_TYPE = 'Connection Type';
export const CAPI = 'CAPI';
export const DIRECT_INTEGRATION = 'Direct Integration';
export const OAUTH_PLATFORMS_FILTER = 'All Platforms';
export const ALL_EMAILS = 'All Emails';
export const CREDENTIAL_GENERATED_AT = 'Credential Generated At';

// OTS Segment Manager
export const OTS_SGM_MNG_LAST_SYNCED = 'Last Synced';
export const OTS_SGM_MNG_SEARCH_SEGMENT_NAME = 'Search Segment Name';
export const OTS_SGM_MNG_NO_SEGMENTS_FOUND = 'No segments found';
export const OTS_SGM_MNG_SEGMENT_NAME = 'Segment Name';
export const OTS_SGM_MNG_RECEIVED_IDS = 'Received Ids';
export const OTS_SGM_MNG_ACTIVE_IDS = 'Active Ids';
export const OTS_SGM_MNG_EFFECTIVE_CPM = 'Effective CPM';
export const OTS_SGM_MNG_LAST_UPDATED = 'Last Updated';
export const OTS_SGM_MNG_POM = 'PoM';
export const OTS_SGM_MNG_CPM = 'CPM';
export const OTS_SGM_MNG_REVENUE = 'Total Revenue';
export const OTS_SGM_MNG_EDIT_AUDIENCE = 'Edit Audience';
export const OTS_SGM_MNG_NO_AUDIENCE_TOOLTIP =
  'No associated audience available for this segment';
export const OTS_SGM_MNG_CREATE_NEW_AUDIENCE = 'Create New Audience';
export const OTS_SGM_MNG_NO_RECORD_FOUND = 'No record found';
export const OTS_SGM_MNG_SEGMENT_NOT_FOUND_MESSAGE =
  'The segment you are looking for does not exist or has been removed.';
export const OTS_SGM_MNG_NO_DESCRIPTION_AVAILABLE = 'No description available';
export const OTS_SGM_MNG_TOTAL_REVENUE = 'Total Revenue';
export const OTS_SGM_MNG_TOTAL_IMPRESSIONS = 'Total Impressions';
export const OTS_SGM_MNG_REVENUE_THIS_MONTH = 'Revenue this Month';
export const OTS_SGM_MNG_IMPRESSIONS_THIS_MONTH = 'Impressions this Month';
export const OTS_SGM_MNG_EFF_CPM = 'Effective CPM';
export const OTS_SGM_MNG_NO_REMODELING_RECORDS = 'No remodeling records found';
export const OTS_SGM_MNG_REMODELING_EXPORT_DATE = 'Export Date';
export const OTS_SGM_MNG_REMODELING_STATUS = 'Status';
export const OTS_SGM_MNG_REMODELING_CUT_SIZE = 'Cut Size';
export const OTS_SGM_MNG_REMODELING_SEED_SIZE = 'Seed Size';
export const OTS_SGM_MNG_REMODELING_DELIVERED_SIZE = 'Delivered Size';
export const OTS_SGM_MNG_AUDIENCE_ID = 'Audience ID';
export const OTS_SGM_MNG_REMODELING_SCHEDULE = 'Schedule';
export const OTS_SGM_MNG_REMODELING_LAST_REMODELED = 'Last Exported';
export const OTS_SGM_MNG_REMODELING_NEXT_REMODEL = 'Next Export';
export const OTS_SGM_MNG_REMODELING_UPDATE_SCHEDULE = 'Update schedule';
export const OTS_SGM_MNG_REMODELING_SCHEDULE_MODAL_TITLE =
  'Remodeling schedule';
export const OTS_SGM_MNG_REMODELING_SCHEDULE_TOGGLE_LABEL =
  'Remodel this segment';
export const OTS_SGM_MNG_REMODELING_SCHEDULE_TOGGLE_DESCRIPTION =
  "Keeps this audience up to date by re-modeling it on a schedule using Attain's look-alike models.";
export const OTS_SGM_MNG_REMODELING_SCHEDULE_OPTIONS = 'Schedule options';
export const OTS_SGM_MNG_REMODELING_SCHEDULE_FREQUENCY_LABEL = 'Frequency:';
export const OTS_SGM_MNG_REMODELING_SCHEDULE_SAVE = 'Save';
export const OTS_SGM_MNG_REMODELING_SCHEDULE_ON = 'On';
export const OTS_SGM_MNG_REMODELING_SCHEDULE_OFF = 'Off';
export const OTS_SGM_MNG_REMODELING_SCHEDULE_SUCCESS =
  'Remodeling schedule updated successfully!';
export const OTS_SGM_MNG_REMODELING_SCHEDULE_ERROR =
  'Failed to save remodeling configuration';
export const OTS_SGM_MNG_REMODELING_SCHEDULE_ERROR_GENERIC =
  'An error occurred while saving the configuration';
export const OTS_SGM_MNG_REMODELING_DISABLED_TOOLTIP =
  'Remodeling is available only for Modeled OTS Segment exports.';
export const OTS_SGM_MNG_REMODELING_OPTIMIZATION_OPTIONS =
  'Optimization options';
export const OTS_SGM_MNG_REMODELING_OPTIMIZED_AUDIENCE_LABEL =
  'Optimized Audience';
export const OTS_SGM_MNG_REMODELING_OPTIMIZED_AUDIENCE_NONE = 'None';
export const OTS_SGM_MNG_REMODELING_OPTIMIZED_AUDIENCE_PLACEHOLDER =
  'Search optimized audience...';
export const OTS_SGM_MNG_TAB_OVERVIEW = 'Overview';
export const OTS_SGM_MNG_TAB_REMODELING = 'Remodeling';
export const OTS_SGM_MNG_LAST_ID_REFRESH = 'Last Audience Refresh';
export const OTS_SGM_MNG_FAILED_TO_FETCH_SEGMENTS = 'Failed to fetch segments';
export const OTS_SGM_MNG_SEGMENTS_SELECTED = 'segments selected';
export const OTS_SGM_MNG_DELETE_SELECTED = 'Delete selected';
export const OTS_SGM_MNG_CLEAR_SELECTION = 'Clear';
export const OTS_SGM_MNG_CONFIRM_BULK_DELETE_TITLE = 'Delete segments';
export const OTS_SGM_MNG_CONFIRM_DELETE = 'Delete';
export const OTS_SGM_MNG_CANCEL = 'Cancel';
export const OTS_SGM_MNG_BULK_DELETE_SUCCESS = 'Segments deleted successfully';
export const OTS_SGM_MNG_BULK_DELETE_NETWORK_ERROR =
  'Could not delete segments. Please try again.';
export const OTS_SGM_MNG_DELETE_RESULTS_TITLE = 'Delete results';
export const OTS_SGM_MNG_DELETE_RESULTS_REQUESTED = 'Requested';
export const OTS_SGM_MNG_DELETE_RESULTS_SUCCEEDED = 'Succeeded';
export const OTS_SGM_MNG_DELETE_RESULTS_FAILED = 'Failed';
export const OTS_SGM_MNG_DELETE_RESULTS_FAILED_SEGMENTS = 'Segments that could not be deleted';
export const OTS_SGM_MNG_DELETE_RESULTS_TABLE_SEGMENT_ID = 'Segment ID';
export const OTS_SGM_MNG_DELETE_RESULTS_TABLE_RESULT = 'Result';
export const OTS_SGM_MNG_DELETE_RESULTS_TABLE_ERROR = 'Error';
export const OTS_SGM_MNG_DELETE_RESULTS_STATUS_SUCCESS = 'Success';
export const OTS_SGM_MNG_DELETE_RESULTS_STATUS_FAILED = 'Failed';
export const OTS_SGM_MNG_DELETE_RESULTS_ERROR_EMPTY = '—';
export const OTS_SGM_MNG_DELETE_RESULTS_CLOSE = 'Close';
export const OTS_SGM_MNG_DELETE_RESULTS_SUMMARY_ALL_OK =
  'All selected segments were removed from the buyable list.';
export const OTS_SGM_MNG_DELETE_RESULTS_SUMMARY_PARTIAL =
  'Some segments were removed; others failed. Review the list below. You can retry failed segments.';
export const OTS_SGM_MNG_DELETE_RESULTS_SUMMARY_NONE =
  'None of the selected segments could be removed.';
export const OTS_SGM_MNG_SEGMENT_SIZE_REVENUE = 'Segment Size & Revenue';
export const OTS_SGM_MNG_SEGMENT_SIZE_REVENUE_SUBTITLE =
  'Active ID counts (number of HEMs) and revenue by month for the past 12 months.';
export const OTS_SGM_MNG_SEGMENT_SIZE_REVENUE_SUBTITLE_QUARTERLY =
  'Active ID counts (number of HEMs) and revenue by quarter for the past 4 quarters.';
export const OTS_SGM_MNG_SEGMENT_SIZE_REVENUE_SUBTITLE_WEEKLY =
  'Active ID counts (number of HEMs) and revenue by week for the past 12 weeks.';
export const OTS_SGM_MNG_SEGMENT_SIZE_REVENUE_WEEKLY_EMPTY =
  'Segment size and revenue are not available for weekly periods. Use Monthly or Quarterly to view this chart.';
export const OTS_SGM_MNG_CHART_DATA_NOT_AVAILABLE = 'Chart data not available';
export const OTS_SGM_MNG_MONTHLY = 'Monthly';
export const OTS_SGM_MNG_QUARTERLY = 'Quarterly';
export const OTS_SGM_MNG_WEEKLY = 'Weekly';
export const OTS_SGM_MNG_ACTIVE_IDS_LABEL = 'Average Active IDs';
export const OTS_SGM_MNG_REVENUE_LABEL = 'Revenue';
export const OTS_SGM_MNG_RECEIVED_IDS_LABEL = 'Average Received IDs';
export const OTS_SGM_MNG_IMPRESSIONS_LABEL = 'Impressions';
export const OTS_SGM_MNG_CPM_LABEL = 'Average CPM';
export const OTS_SGM_MNG_EFF_CPM_LABEL = 'Effective CPM';
export const OTS_SGM_MNG_AVG_RELEVANCE_PCTL = 'Relevancy Score';
export const OTS_SGM_MNG_AVG_VALUE_PCTL = 'Value Score';
export const OTS_SGM_MNG_MATCH_PCT_PCTL = 'Matched Percent Score';
export const OTS_SGM_MNG_PAID_PCT_PCTL = 'Paid Pct Score';
export const OTS_SGM_MNG_CHART_TAB_DELIVERY_REVENUE = 'Delivery & Revenue';
export const OTS_SGM_MNG_CHART_TAB_TRADE_DESK_PERFORMANCE =
  'Trade Desk Performance';
export const OTS_SGM_MNG_TTD_PERFORMANCE_HEADING = 'Trade Desk Performance';
export const OTS_SGM_MNG_TTD_PERFORMANCE_SUBTITLE =
  'Percentile metrics by month for the past 12 months.';
export const OTS_SGM_MNG_TTD_PERFORMANCE_SUBTITLE_QUARTERLY =
  'Percentile metrics by quarter for the past 4 quarters.';
export const OTS_SGM_MNG_TTD_PERFORMANCE_SUBTITLE_WEEKLY =
  'Percentile metrics by week for the past 12 weeks.';
